// src/utils/campAccommodationPermissions.ts
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';

export const canManageBed = async (
  bed: any,
  userRole: string,
  userId: string
): Promise<boolean> => {
  // Admin can manage all beds
  if (userRole === 'admin') return true;

  // Empty beds can be managed by anyone
  if (!bed.pilgrimId) return true;

  // Guide can only manage their pilgrims
  if (userRole === 'guide') {
    return bed.guideId === userId;
  }

  // Organizer can manage pilgrims of their guides
  if (userRole === 'organizer') {
    try {
      const guidesRef = collection(firestore, 'Guides');
      const q = query(guidesRef, where('organizerId', '==', userId));
      const snapshot = await getDocs(q);
      const organizerGuides = snapshot.docs.map(doc => doc.id);
      return organizerGuides.includes(bed.guideId);
    } catch (error) {
      console.error('Error checking organizer permissions:', error);
      return false;
    }
  }

  return false;
};
